import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../store'
import { selectSelf } from '.'
import { FormReducerState } from '../reducers/form'

export const selectFormState = createSelector(selectSelf, (state: RootState) => state.form)
export const selectForm = (id: string) => createSelector(selectFormState, (state: FormReducerState) => state[id] || {})
